<div class="dialog-box-other-bottle-size">
    <h1 mat-dialog-title class="title-text-red">
        {{alertWizardTitle}}
        <button class="close" (click)="closeDialog(false, 0)"></button>
    </h1>
    <mat-dialog-content class="body-messge">

      <div class="mat-elevation-z8">
        <table  mat-table [dataSource]="otherBottleSizes" >
            <!-- Name Column -->
            <ng-container matColumnDef="packCode">
                <th mat-header-cell *matHeaderCellDef width ="30%"> Pack Code </th>
                <td mat-cell *matCellDef="let element" width ="30%"> {{element.packCode}} </td>
            </ng-container>

            <!-- NDC Column -->
            <ng-container matColumnDef="bottleQty">
                <th mat-header-cell *matHeaderCellDef width ="10%"> Bottle Qty </th>
                <td mat-cell *matCellDef="let element" width ="10%"> {{element.bottleQty}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>

      </div>

    </mat-dialog-content>

</div>
